import {
  FaMapMarkerAlt,
  FaMap,
  FaCircle,
  FaListUl,
  FaTag,
  FaCreditCard,
  FaFlask,
  FaStore,
  FaCertificate,
  FaUserMd,
  FaMicroscope,
  FaUserShield,
  FaFileAlt,
  FaShareAlt,
  FaCube,
  FaTimesCircle,
  FaMoneyBillWave,
  FaStethoscope,
  FaFileSignature,
  FaBox,
  FaPercent,
  FaEye,
  FaSortAmountDown,
  FaMedkit,
  FaExternalLinkAlt,
  FaVials,
  FaDollarSign,
  FaQuestionCircle,
  FaCommentDots,
  FaCalendarDay,
  FaUser,
  FaInfoCircle,
  FaUsers,
  FaBuilding,
  FaSitemap,
  FaUserTie,
  FaUsersCog,
  FaThLarge,
  FaChartPie,
  FaCalendarTimes,
  FaFileInvoiceDollar,
  FaHistory,
  FaMoneyCheckAlt,
  FaUserPlus,
  FaClock,
  FaLaptop,
  FaIdCard,
  FaShoppingCart,
} from "react-icons/fa";

export const filteredNavBarLinkLists = [
  {
    category: "Employees",
    links: [
      {
        link: "/branch",
        name: "Branch",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department",
        name: "Department",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/designation",
        name: "Designation",
        icon: (
          <FaUserTie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee",
        name: "Employee",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeType",
        name: "Employee Type",
        icon: (
          <FaUsersCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeCategory",
        name: "Employee Category",
        icon: (
          <FaUsersCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeLeave",
        name: "Employee Leave",
        icon: (
          <FaCalendarTimes
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/leaveLedgerSummary",
        name: "Ledger Summary",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/attendance-report",
        name: "Attendance Report",
        icon: (
          <FaThLarge
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Accounts & Finance",
    links: [
      {
        link: "/commission-ledger",
        name: "Commission Ledger",
        icon: (
          <FaMoneyCheckAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/credit-transfer",
        name: "Credit Transfer",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-advance-payment-list",
        name: "Make Advance Payment",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/parent-margin-settlement",
        name: "Parent Franchise Settlement",
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payment-details",
        name: "Online Payment Details",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payments-and-receive-payment",
        name: "Online Payment Details Type",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/appointment-payment",
        name: "Patient Appointment Payment",
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-report-ledger",
        name: "Patient Coordinator Commission",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-ledger",
        name: "Payment Ledger",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/paymentMode",
        name: "Payment Mode",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type",
        name: "Payment Type",
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payments",
        name: "Payments",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/received-payment",
        name: "Received Payment",
        icon: (
          <FaMoneyCheckAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Administration",
    links: [
      {
        link: "/area",
        name: "Area",
        sectionId: 10,
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/assign-role",
        name: "Assign Report Role",
        sectionId: 11,
        icon: (
          <FaUserShield
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/audit-logs",
        name: "Audit Logs",
        icon: (
          <FaHistory
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/circular",
        name: "Circular",
        sectionId: 12,
        icon: (
          <FaCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/collection-type",
        name: "Collection Type",
        sectionId: 13,
        icon: (
          <FaListUl
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department-type",
        name: "Department Type",
        sectionId: 16,
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/discount-reason",
        name: "Discount Reason",
        sectionId: 18,
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-degree",
        name: "Doctor Degree",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-sepcialization",
        name: "Doctor Specialization",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/document",
        name: "Document",
        sectionId: 22,
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/emp-discount-allowed",
        name: "Discount Allowed",
        sectionId: 17,
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee-franchise-details",
        name: "Employee Franchise Details",
        sectionId: 24,
        icon: (
          <FaUsers
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-type",
        name: "Franchise Type",
        sectionId: 31,
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/leaveHistory",
        name: "Leave History",
        icon: (
          <FaHistory
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lims-panel-wise-bus-report",
        name: "Lims Panel Wise Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/organism",
        name: "Organism",
        sectionId: 52,
        icon: (
          <FaMicroscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-investigation",
        name: "Outsource Investigation",
        sectionId: 53,
        icon: (
          <FaExternalLinkAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-lab",
        name: "Outsource Lab",
        sectionId: 54,
        icon: (
          <FaExternalLinkAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/package-investigation",
        name: "Package Investigation",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type-search-report",
        name: "Payment Type Search Report",
        sectionId: 89,
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/product",
        name: "Product",
        sectionId: 77,
        icon: (
          <FaCube
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/purchase-order",
        name: "Purchase Order",
        sectionId: 78,
        icon: (
          <FaShoppingCart
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/report-role",
        name: "Report Role",
        sectionId: 65,
        icon: (
          <FaFileSignature
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/roles",
        name: "Roles",
        icon: (
          <FaUserShield
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/shareType",
        name: "Share Type",
        sectionId: 72,
        icon: (
          <FaShareAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sections",
        name: "Sections",
        icon: (
          <FaListUl
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/stock-in",
        name: "Stock In",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/terms-condition",
        name: "Terms & Condition",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/vendor",
        name: "Vendor",
        sectionId: 80,
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/zone",
        name: "Zone",
        sectionId: 75,
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "MIS Data",
    links: [
      {
        link: "/franchise-statistics-report",
        name: "Franchise Statistics Report",
        sectionId: 84,
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/zone-statistics-report",
        name: "Zone Statistics Report",
        sectionId: 84,
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-package-booking-statistics",
        name: "Investigation/Package Booking Statistics",
        sectionId: 96,
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/analytics-dashboard",
        name: "Analytics Dashboard",
        sectionId: 96,
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/total-onboarding-data-report",
        name: "Total Onboarding Data",
        sectionId: 96,
        icon: (
          <FaUserPlus
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-payment-ledger",
        name: "Franchise Payment Ledger",
        sectionId: 96,
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Agents / Coordinators",
    links: [
      {
        link: "/lab-department-wise-coordinator-rates",
        name: "Lab Department Wise Coordinator Rates",
        icon: (
          <FaUsers
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department-wise-ip-rates",
        name: "Lab Department Wise IP Rates",
        icon: (
          <FaUsers
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Doctors Management",
    links: [
      {
        link: "/doctor-ip-calculation",
        name: "Doctor IP Calculation",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors",
        name: "Doctor Master",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-onboarding-application",
        name: "Doctor Onboarding Application",
        icon: (
          <FaUserPlus
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-performing-charges",
        name: "Doctor Performing Charges",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Franchise/Panel Management",
    links: [
      {
        link: "/registration",
        name: "New Registration",
        icon: (
          <FaUserPlus
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/camp-bulk-booking",
        name: "Camp Bulk Booking",
        icon: (
          <FaUserPlus
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/package-copy-rate",
        name: "Package Copy Rate",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/new-franchise",
        name: "Document & Download",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise",
        name: "Franchise",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-advance-payment-list",
        name: "Franchise Advance Payment",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master",
        name: "Franchise Copy Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master-approval",
        name: "Franchise Copy Rates Approval",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-investigation-details",
        name: "Franchise Investigation Details",
        icon: (
          <FaInfoCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-onboarding",
        name: "Franchise Onboarding Application",
        sectionId: 94,
        icon: (
          <FaUserPlus
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sample-collection",
        name: "Sample Collection",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-wise-search-report",
        name: "Result Entry",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/pending-onboarding",
        name: "Pending Onboarding",
        sectionId: 95,
        icon: (
          <FaClock
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/kyc-documents",
        name: "KYC",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-copy-rates",
        name: "LIMS Franchise Copy Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate",
        name: "Test Rate",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate-list-excel",
        name: "Test Rate List Excel",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/bill-reset",
        name: "Bill Reset",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Lab Master Data",
    links: [
      {
        link: "/investigation-comment",
        name: "Investigation Comment",
        icon: (
          <FaCommentDots
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-deliveryDays",
        name: "Investigation Delivery Days",
        icon: (
          <FaCalendarDay
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-details",
        name: "Investigation Details",
        icon: (
          <FaInfoCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-help",
        name: "Investigation Help",
        icon: (
          <FaQuestionCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-interpretation",
        name: "Investigation Interpretation",
        icon: (
          <FaCommentDots
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-manager",
        name: "Investigation Manager",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-nabl",
        name: "Investigation NABL",
        icon: (
          <FaMedkit
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-observation",
        name: "Investigation Observation",
        icon: (
          <FaEye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-sequence",
        name: "Investigation Sequence",
        icon: (
          <FaSortAmountDown
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-template",
        name: "Investigation Template",
        icon: (
          <FaFileSignature
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-test",
        name: "Investigation/Test",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department",
        name: "Lab Department",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation",
        name: "Observation Master",
        icon: (
          <FaEye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/package",
        name: "Package",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleType",
        name: "Sample Type",
        icon: (
          <FaCube
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Machine & Instrumentation",
    links: [
      {
        link: "/machine-data",
        name: "Machine Data",
        icon: (
          <FaLaptop
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation-host-code",
        name: "Observation Host Code",
        icon: (
          <FaMicroscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Patient Management",
    links: [
      {
        link: "/membership-card",
        name: "Membership Card",
        icon: (
          <FaIdCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-orders",
        name: "Membership Orders",
        icon: (
          <FaShoppingCart
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-rates",
        name: "Membership Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient",
        name: "Patient",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-appointment-details",
        name: "Patient Appointment Details",
        icon: (
          <FaCalendarDay
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Sample & Accession",
    links: [
      {
        link: "/barcode-tracking",
        name: "Barcode Tracking",
        sectionId: 97,
        allowSuperAdmin: true,
        icon: (
          <FaHistory
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sample-collection",
        name: "Sample Collection",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sample-rejected-appointments",
        name: "Sample Rejected Appointments",
        icon: (
          <FaTimesCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleRejectionReason",
        name: "Sample Rejection Reason",
        icon: (
          <FaTimesCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
];
